import { QueryKey } from '@tanstack/react-query';

import { AccountId, OfferingId, UserId } from '@arrived/models';

export const sharesAvailableKey = ['sharesAvailable'] as readonly unknown[];

export const offeringSharesAvailableKeyFn = (offeringId: OfferingId): QueryKey =>
  sharesAvailableKey.concat(['offerings', offeringId]);

export const accountSharesAvailableKeyFn = (offeringId: OfferingId, accountId: AccountId): QueryKey =>
  sharesAvailableKey.concat(['offerings', offeringId, 'accounts', accountId]);

export const userSharesAvailableKeyFn = (offeringId: OfferingId, userId: UserId): QueryKey =>
  sharesAvailableKey.concat(['offerings', offeringId, 'users', userId]);
